import {
  useEducations,
  usePrMessages,
} from '../../../../../../core/repositories/mypageRepository';
import {useUserProfileInputRate} from '../../../../../../core/repositories/usersMeRepository';
import {useAuth} from '../../../../../../core/usecases/useAuth';
import type {Profile, University, User} from './types';
import {getLatestEducation} from './utils';

export const useProfileData = (): {
  user: User;
  university: University;
  profile: Profile;
  isLoading: boolean;
} => {
  const {user: userData} = useAuth();
  const {data: education, isLoading: isLoadingEducation} = useEducations({});
  const {data: pr, isLoading: isLoadingPr} = usePrMessages({});
  const {profileInputRate, isLoading: isLoadingInputRate} =
    useUserProfileInputRate({});

  const user: User = {
    firstName: userData?.firstName ?? '',
    familyName: userData?.familyName ?? '',
  };

  const currentEducation = education?.ok
    ? getLatestEducation(education.value)
    : null;

  const university: University = {
    name: currentEducation?.universityName ?? '',
    major: currentEducation?.majorName ?? '',
    subject: currentEducation?.subjectName ?? '',
    grade: userData?.grade.name ?? '',
    enrollYear: currentEducation?.enrollYear ?? 0,
    enrollMonth: currentEducation?.enrollMonth ?? 0,
    graduateYear: currentEducation?.graduateYear ?? 0,
    graduateMonth: currentEducation?.graduateMonth ?? 0,
  };

  const profile: Profile = {
    pr: pr?.ok ? pr.value.message : '',
    inputRate: profileInputRate?.ok
      ? profileInputRate.value.profile_input_rate
      : 0,
    firstUnfilledFieldLabel: profileInputRate?.ok
      ? (profileInputRate.value.unfilled_fields[0]?.unfilled_field_label ?? '')
      : '',
    requiredAction: profileInputRate?.ok
      ? (profileInputRate.value.unfilled_fields[0]?.required_action_label ?? '')
      : '',
    profileEditPageLink: profileInputRate?.ok
      ? (profileInputRate.value.unfilled_fields[0]?.profile_edit_page_link ??
        '')
      : '',
    unfilledFields: profileInputRate?.ok
      ? profileInputRate.value.unfilled_fields.map((field) => ({
          unfilledFieldLabel: field.unfilled_field_label,
          requiredActionLabel: field.required_action_label,
          profileEditPageLink: field.profile_edit_page_link,
        }))
      : [],
  };

  const isLoading = isLoadingEducation || isLoadingPr || isLoadingInputRate;

  return {
    user,
    university,
    profile,
    isLoading,
  };
};
